import { Component } from '@theme/component';

/** A continuous announcement bar with an explicit pause control. */
class DimacaveAnnouncementMarquee extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#cleanRepeats();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#cleanRepeats();
  }

  /** Toggle the requested pause without changing text or restarting the loop. */
  togglePause() {
    const control = this.querySelector('[data-marquee-pause]');
    if (!(control instanceof HTMLButtonElement)) return;
    const paused = !this.hasAttribute('paused');
    this.toggleAttribute('paused', paused);
    control.setAttribute('aria-pressed', String(paused));
    control.setAttribute('aria-label', paused ? control.dataset.resumeLabel : control.dataset.pauseLabel);
  }

  #cleanRepeats() {
    // Decorative copies are inert; only the original participates in editing.
    for (const copy of this.querySelectorAll('.dimacave-announcement-marquee__copy')) {
      for (const element of copy.querySelectorAll('[data-shopify-editor-block], [data-shopify-editor-setting]')) {
        element.removeAttribute('data-shopify-editor-block');
        element.removeAttribute('data-shopify-editor-setting');
      }
    }
  }
}

if (!customElements.get('dimacave-announcement-marquee')) {
  customElements.define('dimacave-announcement-marquee', DimacaveAnnouncementMarquee);
}
